/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Alert: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="alert" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M623.3333333333333 396.6666666666668H736.6666666666666V510H623.3333333333333V396.6666666666668zM623.3333333333333 623.3333333333334H736.6666666666666V963.3333333333334H623.3333333333333V623.3333333333334zM680 113.3333333333335C367.2 113.3333333333335 113.3333333333333 367.2000000000001 113.3333333333333 680S367.2 1246.6666666666667 680 1246.6666666666667S1246.6666666666665 992.8 1246.6666666666665 680S992.8 113.3333333333335 680 113.3333333333335zM680 1133.3333333333333C430.1 1133.3333333333333 226.6666666666667 929.9 226.6666666666667 680S430.1 226.6666666666668 680 226.6666666666668S1133.3333333333333 430.1 1133.3333333333333 680S929.9 1133.3333333333333 680 1133.3333333333333z" : "M498.6666666666667 317.3333333333333H589.3333333333334V408H498.6666666666667V317.3333333333333zM498.6666666666667 498.6666666666666H589.3333333333334V770.6666666666666H498.6666666666667V498.6666666666666zM544 90.6666666666666C293.7600000000001 90.6666666666666 90.6666666666667 293.76 90.6666666666667 544S293.7600000000001 997.3333333333334 544 997.3333333333334S997.3333333333334 794.24 997.3333333333334 544S794.24 90.6666666666666 544 90.6666666666666zM544 906.6666666666666C344.08 906.6666666666666 181.3333333333334 743.9200000000001 181.3333333333334 544S344.08 181.3333333333333 544 181.3333333333333S906.6666666666669 344.08 906.6666666666669 544S743.9200000000001 906.6666666666666 544 906.6666666666666z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Alert.displayName = `Blueprint5.Icon.Alert`;
export default Alert;
